import {
  createEnterprise,
  disableEnterpriseById,
  editEnterprise,
  enableEnterpriseById,
  updateEnterpriseAllowedActions,
} from '@enterprise/services/enterpriseService';

import { AllowedActionsDto } from '@enterprise/models/allowed-actions';
import { AxiosResponse } from 'axios';
import CreateEnterprisePayload from '@enterprise/models/dto/enterprise-create.dto';
import { useMutation } from '@tanstack/react-query';

export const useEnableEnterprise = () => {
  const useEnablEnterpriseMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => enableEnterpriseById(mutationVariables.id));

  return useEnablEnterpriseMutation;
};

export const useDisableEnterprise = () => {
  const useEnablEnterpriseMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string; sendEmail: boolean },
    unknown
  >(({ id, sendEmail }) => disableEnterpriseById(id, { sendEmail }));

  return useEnablEnterpriseMutation;
};

export const useCreateEnterpriseRequest = () => {
  const useEnablEnterpriseMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { formData: FormData },
    unknown
  >((mutationVariables) => createEnterprise(mutationVariables.formData));

  return useEnablEnterpriseMutation;
};

export const useEditEnterpriseRequest = () => {
  const useEnablEnterpriseMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string; formData: FormData | CreateEnterprisePayload },
    unknown
  >(({ formData, id }) => editEnterprise(id, formData));

  return useEnablEnterpriseMutation;
};

export const useUpdateConsumptionAllowedActions = () => {
  const useUpdateConsumptionAllowedActionsMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string | undefined; payload: AllowedActionsDto },
    unknown
  >(({ payload, id }) => updateEnterpriseAllowedActions(id, payload));

  return useUpdateConsumptionAllowedActionsMutation;
};
